import{d as i}from"./chunk-JVMPPRNZ.js";function y(r,s){let{apiKey:e,jwt:a,overrideBaseUrl:o}=r,t=i(e,s);if(!t.isValid)throw new Error(t.message);return{apiKey:e,jwt:a,overrideBaseUrl:o}}export{y as a};
